module.exports = __webpack_public_path__ + "assets/images/passengers_phase2.cebc0756858f041156bccbed4e1d4ea8.svg";